const interactiveEl = document.querySelector(
  '[data-works-with-integration-features-three-devices-interactive]'
);
const sliders =
  interactiveEl?.querySelectorAll(
    '[data-works-with-integration-features-three-devices-slider]'
  ) || [];
const slideEls = interactiveEl?.querySelectorAll('[data-slide]') || [];
const countSlideVariants = slideEls.length / sliders.length;
const slideDelay = 4000;
const startingIndex = 1;
let currentIndex = 1;

const activateSlide = (slideIndex) => {
  slideEls.forEach((activeSlideEl) => {
    activeSlideEl.setAttribute('data-active', 'false');
  });

  sliders.forEach((slider) => slider.setAttribute('data-hide', 'false'));

  const selectedSlideEls =
    interactiveEl?.querySelectorAll(`[data-slide="${slideIndex}"]`) || [];

  selectedSlideEls.forEach((selectedSlideEl) => {
    if (selectedSlideEl.hasAttribute('data-passive')) {
      selectedSlideEl
        .closest('[data-works-with-integration-features-three-devices-slider]')
        .setAttribute('data-hide', 'true');
    } else {
      selectedSlideEl.setAttribute('data-active', 'true');
    }
  });
};

let sliderInterval = setTimeout(function initThreeDevicesSliderAutoplay() {
  if (interactiveEl) {
    activateSlide(currentIndex);

    if (currentIndex === countSlideVariants) {
      currentIndex = startingIndex;
    } else {
      currentIndex += 1;
    }

    sliderInterval = setTimeout(initThreeDevicesSliderAutoplay, slideDelay);
  }
}, 0);

export const initActivateFeaturesThreeDevicesSlideBtns = () => {
  if (interactiveEl) {
    const controlEls =
      document.querySelectorAll(
        '[data-works-with-integrations-features-three-devices-content-control]'
      ) || [];

    controlEls.forEach((controlEl) => {
      const slideIndex = controlEl.getAttribute('data-slide');

      controlEl.addEventListener('click', () => {
        activateSlide(slideIndex);
        clearInterval(sliderInterval);
      });
    });
  }
};
